import type { DataViewDesignTokens, DataViewTokenSections } from '@primeuix/themes/types/dataview';

export const root: DataViewTokenSections.Root = {
    borderColor: '{primitive.gray.200}',
    borderWidth: '1px',
    borderRadius: '{primitive.borderRadius.lg}',
    padding: '0'
};

export const header: DataViewTokenSections.Header = {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: '{content.borderColor}',
    borderWidth: '0',
    padding: '{utilitySemantic.spacing.large.6} {utilitySemantic.spacing.large.6} 0 {utilitySemantic.spacing.large.6}',
    borderRadius: '{primitive.borderRadius.lg}'
};

export const content: DataViewTokenSections.Content = {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: 'transparent',
    borderWidth: '0',
    padding: '{utilitySemantic.spacing.medium.4} {utilitySemantic.spacing.large.6}',
    borderRadius: '0'
};

export const footer: DataViewTokenSections.Footer = {
    background: '{content.background}',
    color: '{content.color}',
    borderColor: '{content.borderColor}',
    borderWidth: '1px 0 0 0',
    padding: '{utilitySemantic.spacing.medium.4} {utilitySemantic.spacing.large.6}',
    borderRadius: '0'
};

export const paginatorTop: DataViewTokenSections.PaginatorTop = {
    borderColor: '{content.borderColor}',
    borderWidth: '0 0 1px 0'
};

export const paginatorBottom: DataViewTokenSections.PaginatorBottom = {
    borderColor: '{content.borderColor}',
    borderWidth: '1px 0 0 0'
};

export default {
    root,
    header,
    content,
    footer,
    paginatorTop,
    paginatorBottom
} satisfies DataViewDesignTokens;
